// SimpleDocs preset for hero_motion.js. Four scenes cycle: central app
// windows slide in horizontally and settle; floating panels fly in from the
// sides, rotate, and drift. Layer art: src/images/projects/simpledocs/motion/.
const SCENES = [
  { central: { src: "central-1.webp", x: 59, y: 276, w: 1517, h: 967 }, panels: [
    { src: "p1-a.webp", x: 1269, y: 181, w: 655, h: 125 },
    { src: "p1-b.webp", x: 1269, y: 352, w: 593, h: 83 },
    { src: "p1-c.webp", x: 1269, y: 477, w: 686, h: 98 },
    { src: "p1-d.webp", x: 1269, y: 609, w: 615, h: 87 },
  ] },
  { central: { src: "central-2.webp", x: 179, y: 184, w: 1517, h: 1054 }, panels: [
    { src: "p2-a.webp", x: 1479, y: 73,  w: 136, h: 40 },
    { src: "p2-b.webp", x: 1479, y: 127, w: 384, h: 402 },
    { src: "p2-c.webp", x: 48,   y: 607, w: 483, h: 434 },
  ] },
  { central: { src: "central-3.webp", x: -304, y: 178, w: 1517, h: 1152 }, panels: [
    { src: "p3-a.webp", x: 1271, y: 91,  w: 499, h: 370 },
    { src: "p3-b.webp", x: 1269, y: 486, w: 501, h: 184 },
    { src: "p3-c.webp", x: 1269, y: 712, w: 499, h: 178 },
  ] },
  { central: { src: "central-4.webp", x: 201, y: 203, w: 1517, h: 1054 }, panels: [
    { src: "p4-a.webp", x: 68, y: 100, w: 466, h: 64 },
    { src: "p4-b.webp", x: 64, y: 197, w: 560, h: 217 },
  ] },
]

const STAGE_W = 1920
const STAGE_H = 1080

function build({ reduce, rnd, gsap, addLayer }) {
  const sceneLayers = (reduce ? SCENES.slice(0, 1) : SCENES).map((scene, si) => {
    const items = [{ ...scene.central, central: true }, ...scene.panels]
    return items.map((it) => {
      const layer = addLayer(it)
      const side = (it.x + it.w / 2) > STAGE_W / 2 ? 1 : -1
      if (it.central) {
        const enterSide = (si % 2 === 0) ? -1 : 1
        const offLeft = () => -(it.w + it.x + rnd(90, 320))
        const offRight = () => (STAGE_W - it.x + rnd(90, 320))
        layer.dataset.enterx = (enterSide === -1 ? offLeft() : offRight())
        layer.dataset.exitx = (enterSide === -1 ? offRight() : offLeft())
        layer.dataset.entery = 0; layer.dataset.enterrot = 0
        layer.dataset.exity = 0; layer.dataset.exitrot = 0
      } else {
        layer.dataset.enterx = side * 1150; layer.dataset.entery = rnd(-40, 40); layer.dataset.enterrot = side * rnd(6, 11)
        layer.dataset.exitx = side * 1150; layer.dataset.exity = rnd(-30, 30); layer.dataset.exitrot = side * rnd(8, 14)
      }
      return layer
    })
  })

  const allLayers = sceneLayers.flat()
  const fx = (n) => (i, t) => +t.dataset[n]

  allLayers.forEach((l) => gsap.set(l, { x: +l.dataset.enterx, y: +l.dataset.entery, rotation: +l.dataset.enterrot }))

  if (reduce) {
    sceneLayers[0].forEach((l) => gsap.set(l, { x: 0, y: 0, rotation: 0 }))
    return null
  }

  const idle = []
  allLayers.forEach((l) => {
    if (l._central) return
    idle.push(gsap.to(l._float, {
      y: rnd(6, 14) * (Math.random() < 0.5 ? -1 : 1),
      rotation: rnd(0.6, 1.8) * (Math.random() < 0.5 ? -1 : 1),
      duration: rnd(2.2, 3.4), yoyo: true, repeat: -1, ease: "sine.inOut", delay: rnd(0, 1.5),
    }))
  })

  const tl = gsap.timeline({ repeat: -1 })
  sceneLayers.forEach((layers, si) => {
    const central = layers[0]
    const panels = layers.slice(1)
    tl.fromTo(central,
      { x: +central.dataset.enterx, y: 0, rotation: 0 },
      { x: 0, duration: 1.25, ease: "power2.out" },
      si === 0 ? 0 : "-=0.15")
    tl.fromTo(panels,
      { x: fx("enterx"), y: fx("entery"), rotation: fx("enterrot") },
      { x: 0, y: 0, rotation: 0, duration: 0.95, ease: "power3.out", stagger: { each: 0.09, from: "random" } },
      "<+0.2")
    tl.to({}, { duration: rnd(4.3, 4.9) })
    tl.to(central, { x: +central.dataset.exitx, duration: 1.05, ease: "power2.in" })
    tl.to(panels,
      { x: fx("exitx"), y: fx("exity"), rotation: fx("exitrot"), duration: 0.75, ease: "power3.in", stagger: { each: 0.06, from: "random" } },
      "<")
  })

  return { tl, idle }
}

export default { stage: { w: STAGE_W, h: STAGE_H }, build }
